export default __webpack_public_path__ + "static/media/laconic_main_mobile_large.8813fc9e.jpg";